import React, { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import { FStorage, firebase_Db } from "../../config/firebaseConfig";



import Button from "@material-ui/core/Button";

import "../newProduct/newProduct.css";



const DBName = "Restaurants";

function CreateResaurants({ btnName, titleName, submitType, restaurantData  }) {
  const [restaurantsData, setRestaurantData] = useState({
    name: "",
  });
  const [submit_type, setSubmitType] = useState(false);

  const [imageAsUrl, setImageAsUrl] = useState("");
  const { data, id } = restaurantData;

  useEffect(() => {
    function checkSubmit() {
      if (submitType === "Create") {
        setSubmitType(true);
      } else {
        setSubmitType(false);
      }
    }
    return checkSubmit();
  }, [submitType]);

  const handleImageAsFile = async (e) => {
    const image = e.target.files[0];
    const storageRef = FStorage.ref("restaurants_images");
    const fileRef = storageRef.child(
      `${Math.floor(Math.random() * 135) + 1}` + image.name
    );
    await fileRef.put(image);
   await setImageAsUrl(await fileRef.getDownloadURL());
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setSubmitType(submitType);
    if (submit_type && restaurantsData.name) {
      const ref = firebase_Db.collection(DBName).doc();
      await firebase_Db
        .collection(DBName)
        .add({
          id: ref.id,
          name: restaurantsData.name,
          imgUrl: imageAsUrl,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          alert("Product Added");
          setSubmitType("");
          setRestaurantData({
            name: "",
          });
          setImageAsUrl(null);
        })
        .catch(() => {
          alert("Restaurant not Added");
        });
    } else {
      await firebase_Db
        .collection(DBName)
        .doc(id)
        .update({
          name: restaurantData.name || data.name,
          imgUrl: imageAsUrl || data.imgUrl,
        })
        .then(() => {
          setSubmitType("");
          setRestaurantData({
            name: "",
          });
          setImageAsUrl(null);
          alert("Restaurant Updated");
        })
        .catch(() => {
          alert("Restuarant not able to Updated");
        });
    }
  };

  return (
    <>
      <div className="newProduct">
        <h1 className="addProductTitle">{titleName}</h1>
        <form className="addProductForm" onSubmit={handleOnSubmit}>
          <div className="addProductItem">
            <label htmlFor="name">Name</label>
            <input
              name="name"
              id="name"
              type="text"
              placeholder="Enter Restaurant Name"
              value={restaurantData.name}
              onChange={(e) =>
                setRestaurantData((_) => {
                  return { ...restaurantData, name: e.target.value };
                })
              }
            />
          </div>

          <div className="addProductItem">
            <label htmlFor="img_url">Image</label>
            <input
              type="file"
              name="img"
              id="img"
              onChange={handleImageAsFile}
            />
          </div>
          <Button variant="contained" color="primary" type="submit">
            {btnName}
          </Button>
        </form>
      </div>
    </>
  );
}


export default CreateResaurants;